import React, { useRef, useState, useEffect } from "react";

import Tooltip from "../tooltip";
import { Placement } from "react-bootstrap/esm/types";

import cx from 'classnames';
import styles from "./truncateWithTooltip.module.scss";

interface TruncatedTooltipProps {
  text: string;
  placement?: Placement;
  lines?: number;
  className?: string;
  style?: React.CSSProperties; 
}

const TruncateWithTooltip: React.FC<TruncatedTooltipProps> = ({
  text,
  placement = "top",
  lines = 1,
  className,
  style,
}) => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const isOverflow = el.scrollHeight > el.clientHeight + 1;
      setIsTruncated(isOverflow);
    }
  }, [text, lines]);

  return (
    <Tooltip content={text} placement={placement} disabled={!isTruncated}>
      <div
        ref={textRef}
        className={cx(styles.truncatedText, className)}
        style={{
          WebkitLineClamp: lines,
          ...style, 
        }}
      >
        {text}
      </div>
    </Tooltip>
  );
};

export default TruncateWithTooltip;
